import React, { useState, useEffect } from "react";

import { useDispatch } from "react-redux";

// Data imports
import processorItems from "../../../data/processorItems";

// redux imports
import { resetStore } from "../../../redux/actions/processorsActions";

// Components imports
import ProcessorItem from "../ProcessorItem";
import Button from "../../common/Button";

// Icons imports
import { AiOutlinePlus } from "react-icons/ai";
import { BiEditAlt } from "react-icons/bi";
import { FaRegSave } from "react-icons/fa";

// Scss imports
import css from "./ProcessorsContainer.module.scss";
interface ProcessorsContainerProps {
  editProcessor: any;
  createProcessor: any;
  setRenderedNewProcessorItem: any;
  renderedNewProcessorItem: any;
  firstName: string;
  lastName: string;
  nationalId: string;
  phone: string;
  handleChange: any;
  processors: any;
  addProcessorStatus: any;
  showAllProcessors: boolean;
}

const ProcessorsContainer: React.FC<ProcessorsContainerProps> = ({
  editProcessor,
  createProcessor,
  setRenderedNewProcessorItem,
  renderedNewProcessorItem,
  firstName,
  lastName,
  nationalId,
  phone,
  handleChange,
  processors,
  addProcessorStatus,
  showAllProcessors
}) => {
  // State to store number of children
  const [numberOfChildren, setNumberOfChildren] = useState(0);

  const dispatch = useDispatch();

  // Array with children
  const children: any = [];

  // Function for adding new processor on + button click
  const addNewProcessor = () => {
    setNumberOfChildren(numberOfChildren + 1);
    setRenderedNewProcessorItem(true);
    dispatch(resetStore());
  };

  const handleChangeNewi = (e: any) => {
  };

  // With for loop push new item in array
  for (let i = 0; i < numberOfChildren; i++) {
    children.push(
      <ProcessorItem
        icon={<FaRegSave color="#982d8f" fontSize="2.3rem" />}
        number={processors ? processors.length + 1 : 1}
        deleteIcon={false}
        sendData={createProcessor}
        handleChange={handleChange}
        firstName={firstName}
        lastName={lastName}
        nationalId={nationalId}
        phone={phone}
        newItem={true}
        showAllProcessors={showAllProcessors}
      />
    );
  }

  // Delete processor item
  /*const deleteProcessorFunction = (id) => {
    dispatch(deleteProcessor(id));
	};*/

  return (
    <div className={css.container}>
      {processors
        ? processors.map((processor, index) => {
            return (
              <ProcessorItem
                key={processor.id}
                number={index + 1}
                id={processor.id}
                icon={<BiEditAlt color="#982d8f" fontSize="2.3rem" />}
                deleteIcon={true}
                sendData={editProcessor}
                handleChange={handleChangeNewi}
                /*firstName={processor.name.split(" ")[0]}
                lastName={processor.name.split(" ")[1]}
                nationalId={processor.nationalId}
                phone={processor.nationalId}*/
                /*firstName={e.target.value}
                lastName=""
                nationalId=""
                phone=""*/
                processor={processor}
                newItem={false}
                showAllProcessors={showAllProcessors}
              />
            );
          })
        : ""}
      <div id="addItem" className={css.addItem}>
        {children}
      </div>
      {/* Add new item button */}
      {!showAllProcessors && (
        <div className={css.buttonHolder}>
          <Button
            icon={<AiOutlinePlus color="#982d8f" fontSize="2.3rem" />}
            onButtonClickHandler={addNewProcessor}
            style={{ borderRadius: "5rem", marginLeft: "2rem" }}
            //refButton={refPrevButton}
            disabledButton={renderedNewProcessorItem}
            //hidden={hiddenPrev}
          />
        </div>
      )}
    </div>
  );
};

export default ProcessorsContainer;
